import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

/**
 * Created by Jerker Nord on 2021-12-22.
 */

export class TrueGritGPUPushView extends PIXI.Container implements StageLayer {

    constructor() {
        super();
        this.name = "TrueGritGPUPushView";
    }

    public cleanup():void {
        while(this.children.length > 0) {
            this.removeChildAt(0).destroy();
        }
    }
}